import { FC, useCallback, useContext } from 'react';

import { TextField, ValidationResult, ValidationStatus } from 'components/inputs/text-field/text-field';
import { RedeliveryContext } from '../redelivery-context';
import useRedeliveryApi from '../use-redelivery-api';

const RedeliveryNumber: FC = () => {
  const { findRedelivery } = useRedeliveryApi();
  const { customer, id, location, original, redeliveryNumber, redeliveryNumberRef, setRedeliveryNumber } =
    useContext(RedeliveryContext);

  const validateRedeliveryNumber = useCallback(
    async (input: string): Promise<ValidationResult> => {
      if (!input && input !== original.redeliveryNumber) {
        return { status: ValidationStatus.DEFAULT };
      } else if (!customer?.id) {
        return { status: ValidationStatus.DEFAULT, error: 'Account required for validation' };
      } else if (!location?.id) {
        return { status: ValidationStatus.DEFAULT, error: 'Location required for validation' };
      }
      const response = await findRedelivery(input, customer.id, location.id);
      if (response && response.id !== id) {
        return { status: ValidationStatus.WARNING, error: 'Redelivery number already in use by this customer' };
      } else return { status: ValidationStatus.SUCCESS };
    },
    [customer, findRedelivery, id, location, original.redeliveryNumber]
  );

  return (
    <TextField
      data-cy="redelivery-number-input"
      label="REDELIVERY NUMBER"
      onChange={setRedeliveryNumber}
      ref={redeliveryNumberRef}
      required
      value={redeliveryNumber}
      validate={validateRedeliveryNumber}
    />
  );
};

export default RedeliveryNumber;
